"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    TeachingPopoverSurface: function() {
        return _index.TeachingPopoverSurface;
    },
    renderTeachingPopoverSurface_unstable: function() {
        return _index.renderTeachingPopoverSurface_unstable;
    },
    teachingPopoverSurfaceClassNames: function() {
        return _index.teachingPopoverSurfaceClassNames;
    },
    useTeachingPopoverSurfaceStyles_unstable: function() {
        return _index.useTeachingPopoverSurfaceStyles_unstable;
    },
    useTeachingPopoverSurface_unstable: function() {
        return _index.useTeachingPopoverSurface_unstable;
    }
});
const _index = require("./components/TeachingPopoverSurface/index");
